module.exports = __webpack_public_path__ + "img/phone-transparent-5-layer.eb4ab5e7.png";